export const LANDING_PREVIEW_HOST = "preview.bcall.us";
export const LANDING_PREVIEW_PATH = "/preview";
export function isPublicLandingHost(hostname: string): boolean {
  return ['bcall.us', 'www.bcall.us'].includes(hostname.trim().toLowerCase().replace(/\.$/, ''));
}

function normalizePath(pathname: string): string {
  return `/${pathname.replace(/^\/+|\/+$/g, "")}`;
}

export function isLandingPreviewLocation(hostname: string, pathname: string): boolean {
  const normalizedHost = hostname.trim().toLowerCase().replace(/\.$/, "");
  const normalizedPath = normalizePath(pathname);
  return normalizedHost === LANDING_PREVIEW_HOST || normalizedPath === LANDING_PREVIEW_PATH;
}

export type ProductSurface = "dialer" | "landing" | "profile" | "unavailable";

export function resolveProductSurface(hostname: string, pathname: string): ProductSurface {
  const host = hostname.trim().toLowerCase().replace(/\.$/, "");
  const path = normalizePath(pathname);
  if (host === LANDING_PREVIEW_HOST) return path === "/dialer" ? "unavailable" : "landing";
  if (!["bcall.us", "localhost", "127.0.0.1", "[::1]"].includes(host)) return "unavailable";
  if (path === "/dialer") return "dialer";
  if (path === "/" || path === LANDING_PREVIEW_PATH) return "landing";
  return "profile";
}
